import { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import Swal from 'sweetalert2';
import Select from 'react-select';
import planoContasService from '../../services/planoContasService';
import lancamentoNovaService from '../../services/lancamentoNovaService';


const ModalAlteracaoConta = ({ show, toggleModal, esteiraID, id, contaAtual, atualizarLancamentos }: { show: boolean, toggleModal: Function, id: number, contaAtual: string, esteiraID: number, atualizarLancamentos: Function }) => {

    const [conta, setConta] = useState<any>(null)
    const [carregando, setCarregando] = useState(false)
    const [planoContas, setPlanoContas] = useState<any[]>([])

    useEffect(() => {
        const load = async () => {
            const resultPlanoConta = await planoContasService.listar(esteiraID);
            setPlanoContas(resultPlanoConta);
        }

        load()
    }, [esteiraID])

    const onSubmit = useCallback(async () => {
        if (!carregando) {
            setCarregando(true);

            if (conta || conta == contaAtual) {
                const result = await lancamentoNovaService.alterarConta(id, conta.value);
                atualizarLancamentos(result);
                Swal.fire({
                    text: 'Alteração feita com sucesso',
                    timer: 4000,
                    icon: 'success',
                    showConfirmButton: false
                });

                toggleModal()
            } else {
                Swal.fire({
                    text: ' Por favor selecione uma nova conta.',
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }
            setCarregando(false)
        }


    }, [id, conta, contaAtual, toggleModal]);

    useEffect(() => {
        setConta(contaAtual);
    }, [contaAtual])

    return (
        <Modal fullscreen centered={true} show={show} scrollable onHide={() => toggleModal()}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header" style={{ justifyContent: 'center' }}>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={() => toggleModal()} className="fas fa-arrow-left" style={{ color: '#5E6397' }}></i>
                    </div>
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Alterar Conta</h5>
                </div>
                <div className="modal-body" id="scrollableDiv">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <Select placeholder="Selecione uma conta" isDisabled={carregando} className='form-control' value={conta} onChange={(e: any) => setConta(e || null)} options={planoContas.map((item) => {
                                            return {
                                                label: `${item.codigo} - ${item.descricao}`,
                                                value: item.codigo
                                            }
                                        }) as any[]} />
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <button className='btn btn-success mt-2' onClick={onSubmit} disabled={carregando}>Salvar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default ModalAlteracaoConta;